import React from "react";
import styled from "styled-components";
import './css/mycss.css';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaVaadin, FaXbox, FaXing, FaXingSquare, FaXRay } from "react-icons/fa";

function Footer() {
  return (
    <Container>

      <Section>
        <Title>Indian Highest Awards</Title>
        <Text>
          Discover the nation’s top honors, from the Bharat Ratna to Padma awards and many more.
        </Text>

        <Socials>
          <a href="https://www.facebook.com/incredibleindia/" target="_blank" rel="noreferrer"><FaFacebook size={24} color="#1877F2" /></a>
          <a href="https://www.instagram.com/incredibleindia/" target="_blank" rel="noreferrer"><FaInstagram size={24} color="#E1306C"/></a>
          <a href="https://www.linkedin.com/company/incredibleindia/" target="_blank" rel="noreferrer"><FaLinkedin size={24}/></a>
          <a href="https://x.com/incredibleindia" target="_blank" rel="noreferrer"><FaTwitter size={24} color="#000000ff"/></a>
        </Socials>
      </Section>

      <Column className="footbox">
        <Heading>Explore</Heading>
        <Link href="#">Home</Link>
        <Link href="https://akanshavermaindian.rf.gd/" target="_blank" rel="noreferrer">Personalities</Link>
        <Link href="#">Contact</Link>
      </Column>

      <Column className="footbox">
        <Heading>Resources</Heading>
        <Link href="https://en.wikipedia.org/wiki/India" target="_blank" rel="noreferrer">Wikipedia</Link>
        <Link href="https://india.gov.in/" target="_blank" rel="noreferrer">India Portal</Link>
        <Link href="https://culture.gov.in/" target="_blank" rel="noreferrer">Culture</Link>
      </Column>

      <Column className="footbox">
        <Heading>Contact Info</Heading>
        <SmallText>Email: kumarvivek66508@gmail.com</SmallText>
        <SmallText>Location: Delhi, India</SmallText>
        <Link href="#">Help & Support</Link>
      </Column>

      <Bottom>
        <p>Created with 🧠 and 💪🏻 by <span style={{color:"#ff7043", fontWeight:"bold"}}>Vivek Kumar</span></p>
        <p>© {new Date().getFullYear()} All Rights Reserved.</p>
      </Bottom>

    </Container>
  );
}

export default Footer;



// STYLES BELOW
const Container = styled.footer`
  background: #fff;
  padding: 40px 50px;
  display: grid;
  grid-template-columns: 2fr 1fr 1fr 1fr;
  gap: 40px;
  border-top: 1px solid #eee;

  @media (max-width: 900px) {
    grid-template-columns: 1.5fr 1fr 1fr;
  }

  @media (max-width: 600px) {
    grid-template-columns: 1fr;
    text-align: center;
  }
`;

const Section = styled.div`
  max-width: 300px;

  @media (max-width: 600px) {
    margin: auto;
  }
`;

const Title = styled.h2`
  font-size: 24px;
  margin: 0;
`;

const Text = styled.p`
  margin-top: 8px;
  color: #444;
  line-height: 1.5;

`;

const Socials = styled.div`
  display: flex;
  gap: 12px;
  margin-top: 12px;

  a {
    font-size: 20px;
    padding: 8px;
    background: #e8f0ff;
    border-radius: 8px;
    text-decoration: none;
  }

  @media (max-width: 600px) {
    justify-content: center;
  }
`;

const Column = styled.div`
  display: flex;
  flex-direction: column;
`;

const Heading = styled.h3`
  margin-bottom: 10px;
  font-size: 18px;
`;

const Link = styled.a`
  text-decoration: none;
  color: #333;
  margin-bottom: 6px;
  font-size: 15px;
`;

const SmallText = styled.p`
  color: #555;
  margin-bottom: 6px;
`;

const Bottom = styled.div`
  grid-column: 1 / -1;
  text-align: center;
  margin-top: 30px;
  padding-top: 12px;
  font-size: 14px;
  border-top: 1px solid #eee;
`;
